
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#30B267"}}),_c('path',{attrs:{"d":"M20.225 28.246a5.99 5.99 0 11-8.47-8.471L17.528 14l2.696 2.696-5.294 5.307a2.18 2.18 0 003.066 3.066l5.294-5.294L26 22.47l-5.775 5.775zM21 22l2 3M15 17l3 2","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"26","cy":"14","r":"4","fill":"#fff"}}),_c('path',{attrs:{"d":"M28 14h-4M26 16v-4","stroke":"#30B267","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    